module.exports = __webpack_public_path__ + "img/success-image.d89b8630.png";